var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"padding":"1rem"}},[_vm._v(" Your API token download should start automatically."),_c('br'),_vm._v(" If it doesn't, try refreshing the page."),_c('br'),_vm._v(" If that doesn't work, please contact "+_vm._s(_setup.sysadmin_contact)+". ")])
}
var staticRenderFns = []

export { render, staticRenderFns }